import styled from '@xstyled/styled-components'

export const StyledSharePanel = styled.div({
  display: 'flex',
  gap: 8
})
